<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-14 12:05:24
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-14 19:16:51
 * @FilePath: \pc\coursearrange\src\dataBoard\dataBoard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="padding: 20px 0px 0px 20px;">

      <el-form style="display: flex;flex-wrap: wrap;">
            <el-form-item label="老师姓名:" style="display: flex;width: 33%;">
                <el-select placeholder="请选择老师姓名" v-model="input1" style="width: 100%" clearable filterable>
                    <el-option v-for="item in options"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="老师职级:" style="display: flex;width: 33%;">
                <el-select placeholder="请选择老师职级" v-model="input2" style="width: 100%" clearable filterable>
                    <el-option v-for="item in options1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="审批状态:" style="display: flex;width: 33%;">
                <el-select placeholder="请选择审批状态" v-model="input3" style="width: 100%" clearable filterable>
                    <el-option v-for="item in options2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                </el-select>
            </el-form-item>

            <div style="display: flex;justify-content: end;width: 100%;margin-bottom: 30px; margin-top: 6px;">
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
            </div>

        </el-form>


        <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
            <el-table-column prop="customerStudent" label="老师姓名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="五节规划课成交率" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="现有学员出勤率" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="现有学员留存率" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="周测成绩及培训考核成绩达标次数占三个月内总考试次数百分比" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="审核状态" show-overflow-tooltip>
              <template slot-scope="scope">
                    <span v-if="scope.row.customerIsallpay === 1" style="color:red;">待审批</span>
                    <span v-if="scope.row.customerIsallpay === 2" style="color:red;">审批中</span>
                    <span v-if="scope.row.customerIsallpay === 3">已完成</span>
                    <span v-if="scope.row.customerIsallpay === 4">驳回</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <div style="display: flex;justify-content: space-around;">
                        <el-button type="text" style="color:#00aaff;" @click="handleClickView(1, scope.row)">审批</el-button>
                        <el-button type="text" style="color:#00aaff;" @click="handleClickView(2, scope.row)">详情</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageNum" :page-size="pageSize"
            layout="prev, pager, next,sizes, jumper" :total="total">
        </el-pagination>


        <el-dialog  :center="true" :close-on-click-modal="false" title="审批" :visible.sync="titleDialogShowvisible"  @close="titlerejectDialogShowClr" width="70%">
          <div style="display: flex; width:100%;margin-bottom: 40px;">
              <div style="width:49%;">
                  <div style="margin-bottom: 40px;">
                    <span>老师姓名:</span>
                    <span>张三</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>三个月内连续周测成绩优异次数：</span>
                    <span>3次/</span>
                    <span style="color:red;">3次</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>六个月内规划课课节数：</span>
                    <span>200节/</span>
                    <span style="color:red;">200节</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>是否达到非寒暑假月份的当月第一周稳定规划中（满 5 节课）学员达到 10 名，寒暑假月份的学员需满足转季后的第一周稳定规划中（满 5 节课）学员数达到 10 名：</span>
                    <span>否/</span>
                    <span style="color:red;">是</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>连续 10 个学员满 5 节规划课的续报率：</span>
                    <span>80%/</span>
                    <span style="color:red;">80%</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>内推成功入职员工：</span>
                    <span>2人/</span>
                    <span style="color:red;">2人</span>
                  </div>
              </div>
              <div style="width:49%; margin-left: 10px;">
                  <div style="margin-bottom: 40px;">
                    <span>老师职级:</span>
                    <span>初级老师</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>累计周测成绩优异次数:</span>
                    <span>6次/</span>
                    <span style="color:red;">6次</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>三个月内学员首次规划课成功率：</span>
                    <span>80%/</span>
                    <span style="color:red;">80%</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>任意连续 3 个月内的所有学员首次规划课成功率：</span>
                    <span>80%/</span>
                    <span style="color:red;">80%</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>6 个月内满 20 节课的规划中学员数量：</span>
                    <span>5人/</span>
                    <span style="color:red;">5人</span>
                  </div>
                  <div style="margin-bottom: 40px;">
                    <span>下一晋升职级：</span>
                    <span>中级老师</span>
                  </div>
              </div>
            </div>

            <div slot="footer" class="dialog-footer" style="text-align: end;">
                <el-button size="small" class="btns" style="border-color: #fefefe;background-color: #f6fafe; color: #000;" @click="titlerejectDialogShowClr">取消</el-button>
                <el-button size="small" class="btns" style="border-color: #ef2017;background-color: #ef2017; color: #fff;" @click="titlerejectDialogShowClrB">驳回</el-button>
                <el-button size="small" class="btns" style="border-color: #1ba5e4;background-color: #1ba5e4; color: #fff;" @click="titlerejectDialogShowClrS">确认</el-button>
            </div>
        </el-dialog>


        <el-dialog  :center="true" :close-on-click-modal="false" :title="titleDialogShowvisibletitle1" :visible.sync="titleDialogShowvisible1"  @close="titlerejectDialogShowClr1" width="70%">
            <el-form label-width="100px">
                <el-form-item :label="fromlabel">
                  <el-input type="textarea" :placeholder="placeholderfrom" maxlength="300" show-word-limit v-model="textareainput" :autosize="{ minRows: 6, maxRows: 6 }"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="btns" @click="titlerejectDialogShowClr1">取 消</el-button>
                <el-button size="small" class="btns" type="primary" @click="titlerejectDialogShowSubt1">确 定</el-button>
            </div>
        </el-dialog>


  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { handleStudent, handleTeacher } from "../utils/publicInterface";
import { getStudentsType } from "@/api/fiveClassApi"
import { getTeachers } from "@/api/fiveClassApi"

export default {
  components:{

  },
  data() {
      return{

          options:[],
          options1:[{id:1,realname:'初级老师'},{id:2,realname:'中级老师'},{id:3,realname:'高级老师'},{id:4,realname:'特级老师'}],
          options2:[{id:1,realname:'待审批'},{id:2,realname:'审批中'},{id:3,realname:'驳回'},{id:4,realname:'已完成'}],

          input1:'',
          input2:'',
          input3:'',
          dataList:[],

          pageNum: 1,
          pageSize: 10,
          total: 0,

          form:{
              input1:'',
              input2:true,
              input3:'',
          },

          titleDialogShowvisible:false,
          titleDialogShowvisible1:false,
          textareainput:'',

          fromlabel:'',
          placeholderfrom:'',
          titleDialogShowvisibletitle1:'',

      }
  },

  mounted(){
    getTeachers().then(res => {  this.options = res.data })
  },


  methods:{


      getApiList(){
          let data = {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              commitId: this.input1,
              commitId: this.input2,
              commitId: this.input3,
          }
          axios.post(`${apiBaseUrl}/orderCustomerAudit/find`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {

                if(res.data.code === 200){

                  let data = res.data.data
                  this.dataList = data.records
                  this.pageNum = data.current ? data.current : 0
                  this.pageSize = data.size ? data.size : 10
                  this.total = data.total ? data.total : 0

                  this.$message({ message: res.data.message , type: "success" })
                }
          }).catch((err)=>{
              this.$message({ message: err , type: "error" })
          })
      },


      titlerejectDialogShowClr(){
        this.titleDialogShowvisible = false
      },

      titlerejectDialogShowClr1(){
        this.textareainput = ''
        this.titleDialogShowvisible1 = false
      },

      titlerejectDialogShowSubt1(){
        if(this.textareainput){
          this.textareainput = ''
          this.titleDialogShowvisible1 = false
        }else{
          this.$message({ message: '请填写备注~' , type: "warning" })
        }
      },

      searchBtns(){
          this.getApiList()
      },

      clearBtns(){
          this.input1 = ''
          this.input2 = ''
          this.input3 = ''
          this.getApiList()
      },

      handleSizeChange(e){
          this.pagepageSizeNum = e
          this.getApiList()
      },

      handleCurrentChange(e){
          this.pageNum = e
          this.getApiList()
      },

      handleClickView(type,itme){
        console.log(itme)
        if(type === 2){
          this.titleDialogShowvisible = true
        }
        if(type === 1){
          this.titleDialogShowvisible = true
        }

      },

      titlerejectDialogShowClrB(){
        this.titleDialogShowvisibletitle1 = '审批意见'
        this.fromlabel = '备注：'
        this.placeholderfrom = '请输入意见'
        this.titleDialogShowvisible1 = true
      },
      titlerejectDialogShowClrS(){
        this.titleDialogShowvisibletitle1 = '驳回原因'
        this.fromlabel = '驳回原因：'
        this.placeholderfrom = '请输入驳回原因'
        this.titleDialogShowvisible1 = true
      },
  }

}
</script>


<style scoped lang="less">

  .no-click {
      pointer-events: none;
  }

  .btns{
      background-color: #428BCA;
      border-color: #428BCA;
      color: #fff;
  }


</style>



// WEBPACK FOOTER //
// src/TaskApproval/DowngradeTaskApproval.vue